/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FollowingRouteImport } from './routes/following'
import { Route as BookmarksRouteImport } from './routes/bookmarks'
import { Route as AdminDotsettingsRouteImport } from './routes/admin[.]settings'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersEditRouteImport } from './routes/users/edit'
import { Route as SettingsBlockedRouteImport } from './routes/settings/blocked'
import { Route as UsersUseridIndexRouteImport } from './routes/users/$userid/index'
import { Route as PostsPostidIndexRouteImport } from './routes/posts/$postid/index'
import { Route as UsersUseridFollowRequestsRouteImport } from './routes/users/$userid/follow-requests'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowingRoute = FollowingRouteImport.update({
  id: '/following',
  path: '/following',
  getParentRoute: () => rootRouteImport,
} as any)
const BookmarksRoute = BookmarksRouteImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDotsettingsRoute = AdminDotsettingsRouteImport.update({
  id: '/admin.settings',
  path: '/admin.settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersEditRoute = UsersEditRouteImport.update({
  id: '/users/edit',
  path: '/users/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBlockedRoute = SettingsBlockedRouteImport.update({
  id: '/blocked',
  path: '/blocked',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const UsersUseridIndexRoute = UsersUseridIndexRouteImport.update({
  id: '/users/$userid/',
  path: '/users/$userid/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsPostidIndexRoute = PostsPostidIndexRouteImport.update({
  id: '/posts/$postid/',
  path: '/posts/$postid/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUseridFollowRequestsRoute =
  UsersUseridFollowRequestsRouteImport.update({
    id: '/users/$userid/follow-requests',
    path: '/users/$userid/follow-requests',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/admin.settings': typeof AdminDotsettingsRoute
  '/bookmarks': typeof BookmarksRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/settings/blocked': typeof SettingsBlockedRoute
  '/users/edit': typeof UsersEditRoute
  '/users/$userid/follow-requests': typeof UsersUseridFollowRequestsRoute
  '/posts/$postid': typeof PostsPostidIndexRoute
  '/users/$userid': typeof UsersUseridIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/admin.settings': typeof AdminDotsettingsRoute
  '/bookmarks': typeof BookmarksRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/settings/blocked': typeof SettingsBlockedRoute
  '/users/edit': typeof UsersEditRoute
  '/users/$userid/follow-requests': typeof UsersUseridFollowRequestsRoute
  '/posts/$postid': typeof PostsPostidIndexRoute
  '/users/$userid': typeof UsersUseridIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/admin.settings': typeof AdminDotsettingsRoute
  '/bookmarks': typeof BookmarksRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/settings/blocked': typeof SettingsBlockedRoute
  '/users/edit': typeof UsersEditRoute
  '/users/$userid/follow-requests': typeof UsersUseridFollowRequestsRoute
  '/posts/$postid/': typeof PostsPostidIndexRoute
  '/users/$userid/': typeof UsersUseridIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/about'
    | '/admin.settings'
    | '/bookmarks'
    | '/following'
    | '/login'
    | '/notifications'
    | '/register'
    | '/settings/blocked'
    | '/users/edit'
    | '/users/$userid/follow-requests'
    | '/posts/$postid'
    | '/users/$userid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/settings'
    | '/about'
    | '/admin.settings'
    | '/bookmarks'
    | '/following'
    | '/login'
    | '/notifications'
    | '/register'
    | '/settings/blocked'
    | '/users/edit'
    | '/users/$userid/follow-requests'
    | '/posts/$postid'
    | '/users/$userid'
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/about'
    | '/admin.settings'
    | '/bookmarks'
    | '/following'
    | '/login'
    | '/notifications'
    | '/register'
    | '/settings/blocked'
    | '/users/edit'
    | '/users/$userid/follow-requests'
    | '/posts/$postid/'
    | '/users/$userid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  AdminDotsettingsRoute: typeof AdminDotsettingsRoute
  BookmarksRoute: typeof BookmarksRoute
  FollowingRoute: typeof FollowingRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  RegisterRoute: typeof RegisterRoute
  UsersEditRoute: typeof UsersEditRoute
  UsersUseridFollowRequestsRoute: typeof UsersUseridFollowRequestsRoute
  PostsPostidIndexRoute: typeof PostsPostidIndexRoute
  UsersUseridIndexRoute: typeof UsersUseridIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/following': {
      id: '/following'
      path: '/following'
      fullPath: '/following'
      preLoaderRoute: typeof FollowingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookmarks': {
      id: '/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof BookmarksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin.settings': {
      id: '/admin.settings'
      path: '/admin.settings'
      fullPath: '/admin.settings'
      preLoaderRoute: typeof AdminDotsettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/edit': {
      id: '/users/edit'
      path: '/users/edit'
      fullPath: '/users/edit'
      preLoaderRoute: typeof UsersEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/blocked': {
      id: '/settings/blocked'
      path: '/blocked'
      fullPath: '/settings/blocked'
      preLoaderRoute: typeof SettingsBlockedRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/users/$userid/': {
      id: '/users/$userid/'
      path: '/users/$userid'
      fullPath: '/users/$userid'
      preLoaderRoute: typeof UsersUseridIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/$postid/': {
      id: '/posts/$postid/'
      path: '/posts/$postid'
      fullPath: '/posts/$postid'
      preLoaderRoute: typeof PostsPostidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userid/follow-requests': {
      id: '/users/$userid/follow-requests'
      path: '/users/$userid/follow-requests'
      fullPath: '/users/$userid/follow-requests'
      preLoaderRoute: typeof UsersUseridFollowRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteRouteChildren {
  SettingsBlockedRoute: typeof SettingsBlockedRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsBlockedRoute: SettingsBlockedRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  AdminDotsettingsRoute: AdminDotsettingsRoute,
  BookmarksRoute: BookmarksRoute,
  FollowingRoute: FollowingRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  RegisterRoute: RegisterRoute,
  UsersEditRoute: UsersEditRoute,
  UsersUseridFollowRequestsRoute: UsersUseridFollowRequestsRoute,
  PostsPostidIndexRoute: PostsPostidIndexRoute,
  UsersUseridIndexRoute: UsersUseridIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
